import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || "/api",
  timeout: 90_000,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const SESSION_EXPIRED_MESSAGE_KEY = "sessionExpiredMessage";

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("token");
      if (window.location.pathname !== "/login") {
        sessionStorage.setItem(
          SESSION_EXPIRED_MESSAGE_KEY,
          "Your login session has expired. Please sign in again."
        );
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

export default api;
